import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder} from "@angular/forms";
import {EncryptDecryptService} from "../services/encrypt-decrypt.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-dialog-pj',
  templateUrl: './dialog-pj.component.html',
  styleUrls: ['./dialog-pj.component.css']
})
export class DialogPjComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogPjComponent>, private fb: FormBuilder, private encdec: EncryptDecryptService, private http: HttpClient, @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {
    //console.log(this.data.url + ' ' + this.data.select);
  }

}
